import { forwardRef } from 'react'
import { withLanguageContext } from 'context'
import Link from 'next/link'

const CustomLink = forwardRef(({ selectedLang, options, ...props }, ref) => {
	return (
		<Link scroll={props.scroll} shallow={props.shallow} href={props.url}>
			<a
				rel={props.rel}
				ref={ref}
                aria-label={props.ariaLabel}
				onMouseOver={props.onMouseOver}
				onMouseOut={props.onMouseOut}
				onMouseEnter={props.onMouseEnter}
				onMouseLeave={props.onMouseLeave}
				onClick={props.onClick}
				className={props.className}
				id={props.id && props.id}
				{...options}
			>
				{props.content || props.children}
			</a>
		</Link>
	)
})

export default withLanguageContext(CustomLink, ['selectedLang'])
